// extracted by mini-css-extract-plugin
module.exports = {"link":"TeamMemberDetail_link__iHWYz"};